import React from 'react';
import { classNames, layoutClassNames } from './classNames';
import type { LayoutClassNameProps } from './classNames';

export interface DividerProps extends React.HTMLAttributes<HTMLHRElement>, LayoutClassNameProps {}

const Divider: React.FC<DividerProps> = ({
  className,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <hr
    className={classNames(
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  />
);

export default Divider;
